var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2793_7604",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V80H80V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2793_7604)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.2672 28.5999V51.3998C70.2672 55.1332 68.2672 58.5998 65.0339 60.4998L45.2339 71.9332C42.0006 73.7998 38.0006 73.7998 34.7339 71.9332L14.9338 60.4998C11.7004 58.6332 9.70044 55.1665 9.70044 51.3998V28.5999C9.70044 24.8666 11.7004 21.3998 14.9338 19.4998L34.7339 8.0665C37.9672 6.19984 41.9672 6.19984 45.2339 8.0665L65.0339 19.4998C68.2672 21.3998 70.2672 24.8333 70.2672 28.5999Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 45.833C38.6333 45.833 37.5 44.6997 37.5 43.333V25.833C37.5 24.4663 38.6333 23.333 40 23.333C41.3667 23.333 42.5 24.4663 42.5 25.833V43.333C42.5 44.6997 41.3667 45.833 40 45.833Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 57.5026C39.5665 57.5026 39.1332 57.4026 38.7332 57.2359C38.2998 57.0692 37.9665 56.8362 37.6332 56.5362C37.3332 56.2029 37.0998 55.8359 36.8998 55.4359C36.7332 55.0359 36.6665 54.6026 36.6665 54.1692C36.6665 53.3026 36.9998 52.4359 37.6332 51.8026C37.9665 51.5026 38.2998 51.2696 38.7332 51.1029C39.9665 50.5696 41.4332 50.8692 42.3665 51.8026C42.6665 52.1359 42.8998 52.4692 43.0665 52.9026C43.2332 53.3026 43.3332 53.7359 43.3332 54.1692C43.3332 54.6026 43.2332 55.0359 43.0665 55.4359C42.8998 55.8359 42.6665 56.2029 42.3665 56.5362C41.7332 57.1696 40.8998 57.5026 39.9998 57.5026Z",
    fill: "#016FD0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionExpired);
export default __webpack_public_path__ + "static/media/sessionExpired.c4a7159d231be986699d88481327567d.svg";
export { ForwardRef as ReactComponent };